export function redact(text: string) {
 let count = 0;
 const rules: [string, RegExp][] = [
  ['SECRET', /\b(?:sk[_-](?:live[_-]|test[_-])?|pk_live_|ghp_|AKIA)[A-Za-z0-9_-]{12,}\b/gi],
  ['EMAIL', /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi],
  ['CARD', /\b(?:\d[ -]?){13,19}\b/g], ['SSN', /\b\d{3}-\d{2}-\d{4}\b/g],
  ['PHONE', /(?:\+\d{1,3}[ .-]?)?(?:\(\d{3}\)|\d{3})[ .-]\d{3}[ .-]\d{4}\b/g],
  ['PHONE', /\b\d{10,12}\b/g], ['ORDER', /\b(?:order|invoice|account)[\s#:=-]+(?:[A-Z]{1,5}[-_]?)?\d{4,}\b/gi],
  ['NAME', /\b(?:my name is|customer name:|full name:)\s+[A-Z][a-z]+(?:\s+[A-Z][a-z]+){0,2}/gi],
  ['ADDRESS', /\b\d{1,5}\s+(?:[A-Z][a-z]+\s+){1,4}(?:Street|St|Road|Rd|Avenue|Ave|Lane|Ln|Drive|Dr)\b/gi]
 ];
 for (const [type, regex] of rules) text = text.replace(regex, () => {count++; return `[${type}]`;});
 return {text, count};
}